/**
 * Novelune 品牌 - Home 页面配置
 */
import { homeCommonConfig } from './common'
import type { HomePageConfig } from './types'
import { theme as brandTheme } from '@/config/brands'

const primaryGradient = brandTheme.primaryGradient || 'linear-gradient(90deg, #FFBC7A 0%, #FF6B3D 100%)'

export const theme = {
  homeBg: '',
  tagsBg: '',
  tagActiveBg: brandTheme.primaryColor,
  tagActiveText: brandTheme.textInverse,
  tagInactiveBg: '#FFEEE5',
  tagInactiveText: '#8C5A42',
  tabActiveGradient: `linear-gradient(270deg, ${brandTheme.bgGlobal} 0%, ${brandTheme.primaryColor} 95%)`,
  tabActiveColor: brandTheme.textPrimary,
  stickyHeaderBg: brandTheme.bgGlobal,
  primaryGradient,
  tabBorderColor: 'rgba(255, 138, 76, 0.12)',
  tabBackground: 'rgba(255, 138, 76, 0.05)',
  tabTextColor: 'rgba(31, 43, 77, 0.68)',
  tabActiveBorderColor: 'rgba(255, 138, 76, 0.24)',
  tabActiveBackground: 'rgba(255, 138, 76, 0.12)',
  headerIconColor: 'rgba(31, 43, 77, 0.82)',
  isStorlyn: false,
} as const

export const homeConfig: HomePageConfig = {
  theme,
  texts: homeCommonConfig.texts,
}
